import React, { useEffect, useState } from 'react';
import { Paper, Stack, Typography } from '@mui/material';
import PageContainer from 'src/components/container/PageContainer';
import { useMain } from "../hooks/useMain";

const Appointment = () => {
    // const appointments = [
    //     { clientName: 'John Doe', date: '2023-08-15', service: 'Haircut' },
    //     { clientName: 'Jane Smith', date: '2023-08-17', service: 'Manicure' },
    //     { clientName: 'Mike Johnson', date: '2023-08-18', service: 'Massage' },
    //     // Add more appointments as needed
    // ];
    const [appointment, setAppointment]= useState([])

    const {fetchAppointmentsByStaff,activeStaffId} = useMain();
    useEffect(()=>{
        
        const getData=async()=>{
            const res = await fetchAppointmentsByStaff(activeStaffId);
            setAppointment(res.data);
        }
        getData();
    },[])
console.log(appointment,'appointment')
    return (
        <PageContainer title="Dashboard" description="this is Dashboard">
            <div style={{ marginBottom: '30px' }}>
                <Typography variant="h4" style={{ marginBottom: '20px' }}>Appointments</Typography>
                <Stack direction="row" spacing={2}>
                    {appointment?.map((appointment, index) => (
                        <Paper
                            key={index}
                            elevation={3}
                            style={{
                                backgroundColor: 'white',
                                textAlign: 'center',
                                width: '200px',
                                height: '200px', // Adjust the width and height as needed
                                padding: '20px',
                                borderRadius: '10px',
                                gap: '10px',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                            }}
                        >
                            <Typography variant="h4" style={{ marginBottom: '10px' }}>{appointment.clientName}</Typography>
                            <div style={{ marginTop: '10px' }}>
                                <Typography variant="body2"><strong>Date:</strong> {appointment.dateOfAppointment}</Typography>
                                <br></br>
                                <Typography variant="body2"><strong>Service:</strong> {appointment.serviceSelected?.serviceName}</Typography>
                            </div>
                        </Paper>
                    ))}
                </Stack>
            </div>
        </PageContainer>
    );
};

export default Appointment;
